<template style="height: 100%;">
  <div class="Notest CommonContentSingle-gray">
    <el-container>
      <el-header  style="  background: rgba(255, 255, 255, 1);  min-height: 180px;  height: auto;">
        <div v-bind:class="[isActive ? activeClass : errorClass]">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">

            <!-- <el-form-item :label="$t('original.name')">
              <el-input v-model="formInline.Name" :placeholder="$t('original.name')"></el-input>
            </el-form-item> -->
            <!-- <el-form-item :label="$t('original.account')">
              <el-input v-model="formInline.Student" :placeholder="$t('original.account')"></el-input>
            </el-form-item> -->
            <el-form-item :label="$t('original.languages110')">
              <el-input v-model="formInline.searchData" :placeholder="$t('original.languages111')"></el-input>
            </el-form-item>
            
            <el-form-item :label="$t('original.Name_of_scale')">
              <el-input v-model="formInline.ScaleName" :placeholder="$t('original.Name_of_scale')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('original.Release_theme')">
              <el-select @change="schange" v-model="formInline.PublishID" :placeholder="$t('original.languages3')">
                <el-option v-for="item in GetScaleIssue" :key="item.PublishID" :label="item.PublishSubject" :value="item.PublishID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('original.Release_object')">
              <el-select v-model="formInline.ObjectS" filterable :placeholder="$t('original.Release_object')">
                <el-option v-for="item in Obj" :key="item.id" :label="item.DeptName" :value="item.DeptID"></el-option>
              </el-select>
            </el-form-item>


            <el-form-item :label="$t('original.languages171')">
              <!-- <el-date-picker v-model="formInline.StudyTime" value-format="yyyy-MM-dd" type="date" :placeholder="$t('original.languages3')"></el-date-picker> -->


              <el-select v-model="formInline.StudyTime" :placeholder="$t('original.languages3')">
                <el-option v-for="item in nianji" :key="item.dicKey" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>



            <el-form-item class="cvbb" style="width: 260px">
              <el-button type="primary" @click="onSubmit"> {{ $t('original.screening') }}</el-button>
              <el-button type="primary" @click="onSubmits">{{ $t('original.reset') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-header>
      <el-main style="margin-top: 15px; background: rgba(255, 255, 255, 1)" class="el-Content">
        <el-button type="primary" @click="onSubmitout"> {{ $t('original.Export_data') }}</el-button>
        <el-table v-loading="wloadings" @selection-change="handleSelectionChange" :data="tableData" style="width: 100%; margin-top: 10px" :default-sort="{ prop: 'date', order: 'descending' }">

          <el-table-column :label="$t('original.The_serial_number')" align="left" min-width="6%">
            <template slot-scope="scope" center>
              {{ (pageIndexs - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('original.Name_of_scale')" width="320" min-width="18%">
            <template slot-scope="scope">
              <span>{{ scope.row.PaperName }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('original.Release_theme')" min-width="20%">
            <template slot-scope="scope">
              <span>{{ scope.row.PubName }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('original.account')" min-width="10%">
            <template slot-scope="scope">
              <span>{{ scope.row.UserID }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('original.name')" min-width="10%">
            <template slot-scope="scope">
              <span>{{ scope.row.RealName }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('original.languages55')" min-width="15%">
            <template slot-scope="scope">
              <span>{{ scope.row.DeptName }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('original.languages72')" min-width="10%">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>{{ $t('original.languages72') }}: {{ scope.row.ValidEndDate }}</p>
                <div slot="reference" class="name-wrapper">
                  <span style="margin-left: 10px">{{ scope.row.ValidEndDate }}</span>
                </div>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="tableData.length > 0">
          <el-pagination  @current-change="handleCurrentChange" :current-page.sync="currentPage1" :page-size="10" layout="total, prev, pager, next" :total="Counts"></el-pagination>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import Notest from "./Notest";
export default {
  data() {
    return {
      nianji: [],
      pageIndexs: 1,
      ccfd: true,
      wloadings: false,
      Counts: 0,
      del: [], //删除的数据
      GetScaleIssue: "",
      Obj: [],
      currentPage1: 1,
      activeNames: ["1"],
      activeName: "second",
      input1: "",
      value1: "",
      isActive: true,
      activeClass: "Nac",
      errorClass: "Nac2",
      formInline: {
        Name: "",
        Student: "",
        ScaleName: "",
        Test_time: "",
        PublishID: "",
        ObjectS: "",
        StudyTime: "",
        searchData: "",
      },
      tableData: [],
      checkboxGroup1: [],
    };
  },
  components: {
    Notest,
  },
  methods: {
    handleChange(val) {},
    change() {
      this.isActive = !this.isActive;
    },
    onSubmit() {
      this.loading(1, 0);
      this.currentPage1 = 1;
    },
    onSubmitout() {
      this.$Http_Post("ScaleIssue/GetScaleunmeasured",{pageSize: "10",pageIndex: 1,Nation: "",Sex: "",Study: "",DeriveText: "1",Language: "Chinese",from: this.formInline,})
        .then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            window.location = res.Data;
          } else {
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message,
          });
        });
    },
    handleEdit(index, row) {},
    handleDelete(index, row) {},
    handleCurrentChange(val) {this.loading(val, 0);},
    loading(num, DeriveText) {
      this.pageIndexs = num;
      this.wloadings = true;
      this.$Http_Post("ScaleIssue/GetScaleunmeasured",{pageSize: "10",pageIndex: num,Nation: "",Sex: "",Study: "",DeriveText: DeriveText,Language: "Chinese",from: this.formInline,})
        .then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.wloadings = false;
            this.tableData = res.Data;
            this.Counts = Number(res.Counts);
          } else {
            this.wloadings = false;
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message,
          });
        });
    },
    schange(val) {
      this.Obj = "";
      this.formInline.ObjectS = "";
      this.$Http_Post("ScaleIssue/GetCommonReturnDataTheme",{ PublishID: val})
        .then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Obj = res.Data;
          } else {
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message,
          });
        });
    },
    handleSelectionChange(val) {
      var lsc = [];
      for (var i = 0; i < val.length; i++) {
        lsc.push(val[i].RealName);
      }
      this.del = lsc;
    },
    dels() {
      this.$Http_Post("ScaleIssue/DePaperresult",{PaperResultID: this.del})
      .then((res) => {
        if (res.Code == 200 || res.Code == 0) {

        } else {
          
        }
      })
      .catch((err) => {
        this.$message({
          type: "error",
          message: err.message,
        });
      });
    },
    onSubmits() {
      this.formInline.Name = "";
      this.formInline.Student = "";
      this.formInline.ScaleName = "";
      this.formInline.Test_time = "";
      this.formInline.PublishID = "";
      this.formInline.ObjectS = "";
      this.formInline.StudyTime = "";
      this.formInline.searchData = "";
      this.loading(1, 0);
      this.currentPage1 = 1;
    },
  },
  mounted() {

    this.loading(1, 0);
    this.$Http_Post("ScaleIssue/GetScaleIssue",{pageSize: "200",pageIndex: 1,PublishSubject: "",Condition: ""})
    .then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.GetScaleIssue = res.Data;
        this.formInline.PublishID = res.Data[0].PublishID
        this.schange(this.formInline.PublishID)
      }
    })

    this.$Http_Post("User/GetDictionaryList",{ DicTypCode: "1"}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.nianji = res.Data
      }
    });

  },
};
</script>
<style>
.Test {height: 100%;position: relative;background-color: #fff;}
.Test .el-tabs__nav-scroll {border: 1px solid #e3e3e3;padding-left: 16px;}
.Test .el-tabs__header {margin: 0 0 0px;}
input {width: 300px;}
.Test .el-form--inline .el-form-item {width: 31.5%;margin-bottom: 8px;}
.Test .el-form-item__content {width: 75%;}
.Test .el-form-item__label {width: 70px;text-align: right;}
.Test .el-date-editor {width: 100%;}
.Test .cvde {width: 60% !important;}
.Test .Nac {height: 130px;position: relative;}
.Nac2 {height: 300px;position: relative;border: 1px solid #e3e3e3;padding-top: 20px;padding: 16px;}
.change {width: 40px;margin-left: -80px;display: inline-block;height: 22px;margin-top: 22px;position: absolute;z-index: 10;cursor: pointer;color: #5e5a5a;}
.Test .cvbb {margin-bottom: 30px;}
.Test .Thelist {padding: 16px;background-color: #fff;min-height: 480px;border: 1px solid #e3e3e3;margin-top: 20px;}
.el-tooltip__popper {max-width: 20%;}
.el-tooltip__popper, .el-tooltip__popper.is-dark {background: #f5f5f5 !important;color: #303133 !important;}
.Test .block {float: right;margin-top: 20px;}
.Test .el-select {width: 100% !important;}
.Notest .el-input__inner {height: 36px;}
.Notest .Thelist {padding-bottom: 70px;}
.Notest .el-table .cell {text-align: center;}
</style>
